import { get } from "../../utils/objectHelpers";

$ {
    const container = get(input, "containers.[0]", {});
    const title = get(container, "title", null);
    const previousText = get(container, "controls.carousel.previous.accessibilityText", null);
    const nextText = get(container, "controls.carousel.next.accessibilityText", null);
    const cards = get(container, "cards", []);
    const imageSize = input.isSmall ? 160 : 300;
}

<section class='str-items-carousel app-layout--negate-gutters-small'>
    <str-title ...title />
    <ebay-carousel
        a11y-previous-text=previousText
        a11y-next-text=nextText
    >
        <for|card, idx| of=cards>
            <@item key=idx>
                <str-item-card ...card class=card._type imageSize=imageSize isSmall=input.isSmall simplified=true />
            </@item>
        </for>
    </ebay-carousel>
</section>

